<template>
  <div class="table-wrapper linebottomg" v-if="this.dataCc && this.dataCc.ETFSHORTNAME">
    <div>
      <p class="table-title">
        <span>
          <i />
          <span>重仓基金({{holdAsset.JJ}}%)</span>
        </span>
        <span class="date-title" >{{holddate}}
        </span>
      </p>

      <div class="thead">
        <div v-for="(hItem,hIndex) in tHeadData" :key="hIndex">
          <img src alt v-if="hIndex === 0" />
          <span class="hItem-text">{{hItem}}</span>
        </div>
      </div>

      <div>
        <div class="bItem" @click="cLickFund(dataCc)">
          <div>
            <span class="bItem-name">{{this.dataCc.ETFSHORTNAME}}</span>
          </div>
          <div>
            <span class="bItem-proportion">{{holdAsset.JJ}}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import StoreManger from '@/utils/FundHQJHManger';

export default {
  // 006757 例子
  name: 'FundTablePositionszj',
  components: {},
  data() {
    return {
      precent: 0,
      fundCode: '',
      nativeData: {},
      dataCc: {},
      holddate: '',
      holdAsset: {},
      tHeadData: ['基金名称', '', '', '持仓占比'],
    };
  },
  computed: {
  },
  watch: {
  },
  mounted() {},
  methods: {
    configDate(item) {
      console.log(item);
      if (!item) {
        return { JJ: '--', FSRQ: '--' };
      }
      const data = item.Datas[0];
      if (data) {
        return data;
      }
      return { JJ: '--', FSRQ: '--' };
    },
    handleData() {
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);

      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/Index',
        params: {
          fundCode: code,
          fundName: name,
          index: '1',
        },
      });
    },
    async render(iscache) {
      this.assdate = StoreManger.getFundJJCCAssetExpansion();
      this.holddate = StoreManger.getFundJJCCExpansion();
      this.nativeData = this.$store.state.native.fund;
      this.fundCode = this.nativeData.fundCode;
      this.loadData(iscache);
    },
    async loadData() {
      const basedata = StoreManger.getFundJJCC();
      if (basedata) {
        this.dataCc = basedata.InverstPosition;
        const Asset = basedata.AssetAllocation;
        const holddate = StoreManger.getFundJJCCExpansion();
        if (!holddate || !Asset) {
          this.dataCc = { JJ: '--' };
        } else {
          const newAss = Asset[holddate];
          if (newAss.length > 0) {
            // eslint-disable-next-line prefer-destructuring
            this.holdAsset = newAss[0];
          }
        }
      }
    },
    cLickFund(item) {
      if (item) {
        const fund = item.ETFCODE;
        const linkTo = `fund://page/funddetail?fundcode=${fund}&id=${fund}`;
        detailPushPage({
          type: 1,
          url: linkTo,
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.table-wrapper {
  padding: 0 24px;
}
.gray {
  color: @app-color-stay;
}
.red {
  color: @app-color-up;
}
.green {
  color: @app-color-down;
}
.table-title {
  font-family: DINAlternate-Bold;
  font-size: 30px;
  color: #000000;
  line-height: 84px;
  height: 84px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  i {
    width: 10px;
    height: 10px;
    background-color: #D699FF;
    margin-right: 10px;
    display: inline-block;
    border-radius: 50%;
    position: relative;
  }
}
.date-title{
  color: #999999;
  text-align: right;
  align-items: center;
  display: flex;
}

.thead {
  display: flex;
  justify-content: space-between;
  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:nth-child(1) {
      align-items: flex-start;
    }
    &:nth-last-child(1) {
      align-items: flex-end;
    }
  }
}

.hItem-text {
  height: 40px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  line-height: 40px;
}

.bItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 30px 0;
  > div {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:nth-child(1) {
      width: 600%;
      align-items: flex-start;
    }
    &:nth-last-child(1) {
      width: 20%;
      align-items: flex-end;
    }
  }
  &-name {
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #000000;
    line-height: 30px;
  }
  &-code {
    font-family: DINAlternate-Bold;
    font-size: 24px;
    color: #666666;
    text-align: right;
    line-height: 24px;
  }
  &-price {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    text-align: center;
    line-height: 30px;
    margin-bottom: 10px;
  }
  &-priceRatio {
    font-family: DINAlternate-Bold;
    font-size: 24px;
    text-align: center;
    line-height: 24px;
  }
  &-proportion {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    color: #000000;
    text-align: center;
    line-height: 30px;
    min-width: 100px;
  }
  &-previous {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    color: #000000;
    text-align: right;
    line-height: 30px;
  }
}

.right-arrow {
  margin-left: 5px;
  width: 32px;
  height: 32px;
}
</style>
